exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__switch___3dwxD {\n  cursor: unset; }\n\n.styles__icon___tHwx5 {\n  height: 25px;\n  width: 100%;\n  vertical-align: middle; }\n\n.styles__exchangeIconContainer___2FXZU {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 54px; }\n", ""]);

// exports
exports.locals = {
	"switch": "styles__switch___3dwxD",
	"icon": "styles__icon___tHwx5",
	"exchangeIconContainer": "styles__exchangeIconContainer___2FXZU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/Money/styles.scss
// module id = 4623
// module chunks = 6